import { render, staticRenderFns } from "./allfavoris.vue?vue&type=template&id=25966694"
import script from "./allfavoris.js?vue&type=script&lang=js&external"
export * from "./allfavoris.js?vue&type=script&lang=js&external"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports